module.exports = __webpack_public_path__ + "img/song_2.763b49d4.png";